<template>
  <div class="min-h-full text-grey-main flex flex-col bg-white px-15">
    <LogoModule class="pt-40 md:pl-25" />

    <div class="w-full max-w-380 mx-auto mt-30 md:m-auto">
      <div class="flex flex-col items-start m-15">
        <div class="text-center w-full">
          <p class="text-24 font-bold">New password</p>
          <p>We received your password reset request</p>
          <p class="mb-40">Please enter your new password</p>
        </div>

        <InputModule
          v-model="user.password"
          name="password"
          type="password"
          label="Enter password"
          placeholder="New password"
          class="w-full mb-30 font-bold"
          input-classes="px-22 py-14"
          :error-message="errorMessages.password"
          @clearErrorMessage="name => errorMessages[name] = null"
        />

        <InputModule
          v-model="user.confirmPassword"
          name="confirmPassword"
          type="password"
          label="Confirm password"
          placeholder="Confirm password"
          class="w-full mb-30 font-bold"
          input-classes="px-22 py-14"
          :error-message="errorMessages.confirmPassword"
          @clearErrorMessage="name => errorMessages[name] = null"
        />

        <ButtonModule
          text="Continue"
          class="w-full justify-center bg-brand hover:bg-brand-hover text-white text-16 font-bold rounded-4 mb-30 py-20 px-67"
          @click="passwordReset"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import InputModule from '@/components/shared/form-controls/InputModule'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import LogoModule from '@/components/shared/LogoModule'

import { requiredFieldsValidation, passwordValidation } from '@/helpers'
import { authService } from '@/services'

export default defineComponent({
  name: 'ResetPasswordView',

  components: { InputModule, ButtonModule, LogoModule },

  setup () {
    const step = ref(1)
    const user = reactive({
      password: null,
      confirmPassword: null
    })
    const errorMessages = reactive({
      password: null,
      confirmPassword: null
    })

    const { commit } = useStore()
    const route = useRoute()
    const router = useRouter()

    function passwordReset () {
      requiredFieldsValidation(errorMessages, user)

      if (!errorMessages.password) {
        errorMessages.password = passwordValidation(user.password)
      }

      if (!errorMessages.confirmPassword) {
        errorMessages.confirmPassword = passwordValidation(user.confirmPassword)
      }

      if (user.password !== user.confirmPassword && !errorMessages.confirmPassword) {
        errorMessages.confirmPassword = 'password and confirm password does not match'
      }

      if (Object.values(errorMessages).every(i => !i)) {
        authService.passwordReset({ ...route.query, password: user.password }).then(({ data }) => {
          commit('setToken', data.token)
          router.push('/')
        })
      }
    }
    return {
      // refs
      step,
      // reactive
      user,
      errorMessages,
      // function
      passwordReset
    }
  }
})
</script>
